import React from 'react'
import { Link } from 'react-router-dom'

const NovaCareerAbout = () => {
  return (
    <div className='container mtop-5'>
        <h2 className='heading text-start mb-3'>
          Education Consultancy Careers at <br/>
          Nova EduBridge
        </h2>

        <p className='text-muted text-start'>
          At Nova EduBridge, we believe our people are the driving force behind our success. As part of our <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>education consultancy careers</Link>, we are a passionate, student-focused organization dedicated to helping individuals achieve their dreams of studying, working, and building a future abroad. Every team member plays a vital role in shaping the journey of our students — from their first counselling session to their first day in a new country.
        </p>
    </div>
  )
}

export default NovaCareerAbout